import { setBedrockProviderModule } from "@open-hax/eta-mu-ai";
import { bedrockProviderModule } from "@open-hax/eta-mu-ai/bedrock-provider";

setBedrockProviderModule(bedrockProviderModule);
